<template>
  <div class="flex flex-col justify-between min-h-screen bg-skin-base text-skin-base">
    <div class="flex flex-col justify-start items-stretch">
      <app-header class="relative top-0 left-0 z-[2]" />
      <main class="overflow-hidden relative top-0 left-0 w-full py-5xl">
        <wrapper-blocks>
          <block class="flex flex-col gap-layout px-edge justify-center items-center">
            <h1 class="text-display-1 text-center">{{ error.statusCode }}</h1>
            <div class="text-body text-center" v-html="error.message"></div>
          </block>
        </wrapper-blocks>
      </main>
    </div>

    <app-footer />
  </div>
</template>

<script setup>
const props = defineProps({
  error: Object
});

const handleError = () => clearError({ redirect: "/" });
</script>
